import React, { memo } from 'react'

import { string, bool, func } from 'prop-types'

import Link from 'src/common/components/link'
import classNames from 'src/common/helpers/class-names'

import MeatSticker from './meat-sticker'

const blk = 'link-save-banner'

const breakpoints = {
  default: 320,
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1200,
}

const makeMediaQueryPredicates = (width) => {
  const {
    default: base, small, medium, large, xlarge,
  } = breakpoints

  return {
    'default-up': width >= base,
    'default-only': width < small - 1,
    'small-up': width >= small,
    'small-only': width >= small && width < medium - 1,
    'small-down': width < medium - 1,
    'medium-up': width >= medium,
    'medium-only': width >= medium && width < large - 1,
    'medium-down': width < large - 1,
    'large-up': width >= large,
    'large-only': width >= large && width < xlarge - 1,
    'large-down': width < xlarge - 1,
    'xlarge-up': width >= xlarge,
  }
}


const getBannerName = ({
  isSmallView,
  mix,
  alwaysShowLarge,
  responsive,
  elt,
  mods = [],
}) => {
  const largeView = classNames({
    blk: `${blk}-large`,
    elt,
    mix,
    mods,
  })
  const smallView = classNames({
    blk: `${blk}-small`,
    elt,
    mix,
    mods,
  })
  if (alwaysShowLarge) return largeView
  if (!responsive || isSmallView) return smallView
  return largeView
}

const getModName = (disabled, url) => {
  if (disabled || !url) return []
  return ['hyperlink']
}

const Banner = (props) => {
  const {
    mix,
    disabled,
    responsive,
    url,
    alwaysShowLarge,
    clickHandler,
  } = props
  const hyperlinkMod = getModName(disabled, url)
  const width = document.documentElement.clientWidth || window.innerWidth || 0
  const ruleMap = makeMediaQueryPredicates(width)
  const isSmallView = ruleMap['default-only']
  const anchorClass = getBannerName({
    isSmallView,
    mix,
    alwaysShowLarge,
    responsive,
    elt: 'anchor',
    mods: hyperlinkMod,
  })
  const baseName = getBannerName({ isSmallView, alwaysShowLarge, responsive })
  return (
    <Link
      data-auto-id='linkPromoDetail'
      asAnchor
      className={anchorClass}
      href={url}
      target='_blank'
      rel='noopener noreferrer'
      clickHandler={clickHandler}
    >
      <MeatSticker {...props} baseName={baseName} />
    </Link>
  )
}

Banner.propTypes = {
  responsive: bool,
  url: string,
  disabled: bool,
  alwaysShowLarge: bool,
  mix: string,
  clickHandler: func,
}

Banner.defaultProps = {
  responsive: false,
  url: '',
  disabled: false,
  alwaysShowLarge: false,
  mix: '',
  clickHandler: x => x,
}

export default memo(Banner)



// WEBPACK FOOTER //
// ./shared/interim/product/link-save-primary-banner/banner.js